import type { InputHTMLAttributes } from 'react';
import { sanitizePostal } from './inputMask';

type PostalInputProps = Omit<
  InputHTMLAttributes<HTMLInputElement>,
  'value' | 'onChange' | 'type'
> & {
  value: string;
  onChange: (value: string) => void;
};

/**
 * Controlled SG postal-code input: opens the numeric keypad on mobile
 * (`inputMode="numeric"`), caps at 6 digits, and strips non-digits. All other
 * input attributes (className, placeholder, onBlur, …) pass through.
 */
export default function PostalInput({ value, onChange, ...rest }: PostalInputProps) {
  return (
    <input
      {...rest}
      type="text"
      inputMode="numeric"
      maxLength={6}
      value={value}
      onChange={(e) => onChange(sanitizePostal(e.target.value))}
    />
  );
}
